export function applySeo(document, pathname, settings) {
  const path = pathname === '/' ? '/' : pathname.replace(/\/+$/, '') + '/';
  const page = settings.pages[path];
  if (!page) return;
  const url = settings.origin + path;
  document.title = page.title;
  const meta = (attribute, key, content) => {
    let node = document.head.querySelector(`meta[${attribute}="${key}"]`);
    if (!node) {
      node = document.createElement('meta');
      node.setAttribute(attribute, key);
      document.head.appendChild(node);
    }
    node.setAttribute('content', content);
  };
  meta('name', 'description', page.description);
  meta('name', 'robots', 'index, follow, max-image-preview:large');
  for (const [key, content] of Object.entries({
    'og:type': 'website', 'og:locale': 'es_PY', 'og:site_name': 'Pro360',
    'og:title': page.title, 'og:description': page.description, 'og:url': url,
    'og:image': settings.origin + settings.image,
    'og:image:alt': 'Muestra de la plantilla Editorial Botánica de Pro360 Plus'
  })) meta('property', key, content);
  meta('name', 'twitter:card', 'summary_large_image');
  meta('name', 'twitter:title', page.title);
  meta('name', 'twitter:description', page.description);
  meta('name', 'twitter:image', settings.origin + settings.image);
  meta('name', 'twitter:image:alt', 'Muestra de invitación digital Pro360 Plus');
  let canonical = document.head.querySelector('link[rel="canonical"]');
  if (!canonical) {
    canonical = document.createElement('link');
    canonical.rel = 'canonical';
    document.head.appendChild(canonical);
  }
  canonical.href = url;
  let schema = document.getElementById('seo-schema');
  if (!schema) {
    schema = document.createElement('script');
    schema.id = 'seo-schema';
    schema.type = 'application/ld+json';
    document.head.appendChild(schema);
  }
  schema.textContent = JSON.stringify({
    '@context': 'https://schema.org',
    '@graph': [
      { '@type': 'Organization', '@id': settings.origin + '/#organization', name: 'Pro360', url: settings.origin + '/' },
      { '@type': 'WebSite', '@id': settings.origin + '/#website', name: 'Pro360 | Invitaciones Digitales Plus', url: settings.origin + '/', inLanguage: 'es', publisher: { '@id': settings.origin + '/#organization' } },
      { '@type': path === '/plantillas/' ? 'CollectionPage' : 'WebPage', '@id': url + '#webpage', url, name: page.title, description: page.description, inLanguage: 'es', isPartOf: { '@id': settings.origin + '/#website' } }
    ]
  });
}
